import type * as React from 'react';

import { OverlayFocusContainedContext, ScreenTypeProvider } from '@gitbook/spine-react';

import { UsingKeyboardContextProvider } from './Events';
import { Palette, type PaletteProps, useIsPaletteOpened } from './Palette';
import { ThemeConfigurationProvider } from './theme';

type UIKitProviderProps = {
    children: React.ReactNode;
    /**
     * Use Spine Menu to display the palette.
     */
    usePaletteMenu: PaletteProps['useMenu'];
};

/**
 * Provider for all the contexts.
 */
export function UIKitProvider(props: UIKitProviderProps): React.ReactElement {
    const { children, usePaletteMenu } = props;
    const isPaletteOpened = useIsPaletteOpened();
    return (
        <ThemeConfigurationProvider>
            <ScreenTypeProvider>
                <UsingKeyboardContextProvider>
                    <OverlayFocusContainedContext.Provider value={!isPaletteOpened}>
                        <Palette useMenu={usePaletteMenu} />
                        {children}
                    </OverlayFocusContainedContext.Provider>
                </UsingKeyboardContextProvider>
            </ScreenTypeProvider>
        </ThemeConfigurationProvider>
    );
}
